var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-table", {
    attrs: {
      data: _vm.tableData.list,
      border: "",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "ID",
      prop: "id",
      "min-width": "40"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "状态",
      prop: "state",
      "min-width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c("el-tag", {
          attrs: {
            size: "medium",
            type: _vm.stateTag[row.state]
          }
        }, [_vm._v(" " + _vm._s(_vm.getStateName(row.state)) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "服务器"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var row = _ref2.row;
        return [_vm._v(" " + _vm._s(row.server_id) + "（" + _vm._s(_vm.gameServerMap[row.server_id]) + "） ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "角色列表",
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var row = _ref3.row;
        return _vm._l(row.role_list.split(","), function (roleId) {
          return _c("div", {
            key: roleId
          }, [_vm._v(" " + _vm._s(roleId) + "（" + _vm._s(_vm.tableData.role_name[roleId]) + "） ")]);
        });
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "申请时间",
      prop: "apply_date",
      "min-width": "90"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "申请人",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var row = _ref4.row;
        return [_vm._v(" " + _vm._s(_vm.userInfoMap[row.apply_id]) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "申请原因",
      prop: "apply_reason"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "审核时间",
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var row = _ref5.row;
        return [_vm._v(" " + _vm._s(row.state > 1 ? row.approve_date : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "审核人",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var row = _ref6.row;
        return [_vm._v(" " + _vm._s(row.state > 1 ? _vm.userInfoMap[row.approve_id] : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "审核备注"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref7) {
        var row = _ref7.row;
        return [_vm._v(" " + _vm._s(row.state > 1 ? row.approve_reason : "") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref8) {
        var row = _ref8.row;
        return [_vm.isApprove ? _c("el-button", {
          attrs: {
            type: "primary",
            disabled: _vm.getApproveDisabled(row)
          },
          on: {
            click: function click($event) {
              return _vm.onApprove(row);
            }
          }
        }, [_vm._v(" 审批 ")]) : _c("el-button", {
          attrs: {
            disabled: _vm.getEditDisabled(row)
          },
          on: {
            click: function click($event) {
              return _vm.onEdit(row);
            }
          }
        }, [_vm._v(" 修改 ")])];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };